import PropTypes from 'prop-types';

function TableHeaderCell(props) {
  const {
    display=true, label='', style={}, isSortable=false, sortAttribute='',
    currentSortOrderAttribute='', isCurrentSortOrderAscending=false,
    onSort=null, children=null
  } = props;

  if (display) {
    const thContent = children || label;

    if (isSortable) {
      return (
        <th className='sortable' onClick={() => onSort(sortAttribute)} style={style}>
          {thContent}
          {currentSortOrderAttribute === sortAttribute ? (
            isCurrentSortOrderAscending ? (
              <i className="bx bx-chevron-up" />
            ) : (
              <i className="bx bx-chevron-down" />
            )
          ) : (
            null
          )}
        </th>
      );
    }
    else {
      return <th style={style}>{thContent}</th>;
    }
  }
  return null;
}

TableHeaderCell.propTypes = {
  display: PropTypes.bool,
  style: PropTypes.object,
  isSortable: PropTypes.bool,
  sortAttribute: PropTypes.string,
  currentSortOrderAttribute: PropTypes.string,
  isCurrentSortOrderAscending: PropTypes.bool,
  onSort: PropTypes.func,
  children: PropTypes.node
};

export default TableHeaderCell;